import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const bodenorImages = [{
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oUhxT99v4xajpy7AExfcMX/BODENOR.00_00_21_03.Imagen_fija006.jpg',
  caption: 'Complejo Logístico diseñado para Expansión Regional.'
}, {
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rVuZQebvVZyNmYcWBANaRq/BODENOR.00_00_37_10.Imagen_fija007.jpg',
  caption: 'Seguridad y Vigilancia'
}, {
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3jpmy6rh7yG4rRtNNFC3pZ/BODENOR.00_00_39_20.Imagen_fija008.jpg',
  caption: 'Servicio de Báscula'
}, {
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dgvMAZdDhuPmWxvuW1c2zN/BODENOR.00_00_47_09.Imagen_fija003.jpg',
  caption: 'Amplias y Modernas Bodegas'
}, {
  url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k1dEVj6aPs8tPY4Xd8o4nx/BODENOR.00_01_03_02.Imagen_fija010.jpg',
  caption: 'Amplia Maniobrabilidad'
}];
export function Carousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const goToPrevious = () => {
    setDirection(-1);
    setCurrentIndex(prevIndex => prevIndex === 0 ? bodenorImages.length - 1 : prevIndex - 1);
  };
  const goToNext = () => {
    setDirection(1);
    setCurrentIndex(prevIndex => prevIndex === bodenorImages.length - 1 ? 0 : prevIndex + 1);
  };
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };
  return <section className="bg-black py-16 px-4 relative overflow-hidden" data-id="element-28">
      {/* Background accent */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-yellow-400/5 blur-3xl" data-id="element-29" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-30">
        <div className="relative aspect-[21/9] rounded-xl overflow-hidden group" data-id="element-31">
          <AnimatePresence initial={false} custom={direction} data-id="element-32">
            <motion.img key={currentIndex} src={bodenorImages[currentIndex].url} alt={bodenorImages[currentIndex].caption} className="absolute w-full h-full object-cover" custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
            x: {
              type: 'spring',
              stiffness: 300,
              damping: 30
            },
            opacity: {
              duration: 0.2
            }
          }} data-id="element-33" />
          </AnimatePresence>

          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent flex items-end" data-id="element-34">
            <AnimatePresence mode="wait" data-id="element-35">
              <motion.p key={currentIndex} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -20
            }} transition={{
              duration: 0.3
            }} className="text-white text-lg md:text-xl font-semibold p-8 max-w-3xl" data-id="element-36">
                {bodenorImages[currentIndex].caption}
              </motion.p>
            </AnimatePresence>
          </div>

          <motion.button whileHover={{
          scale: 1.1,
          backgroundColor: 'rgba(252, 211, 77, 1)'
        }} whileTap={{
          scale: 0.95
        }} onClick={goToPrevious} className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 text-white p-3 rounded-full transition-all duration-300 opacity-0 group-hover:opacity-100 backdrop-blur-sm" aria-label="Imagen anterior" data-id="element-37">
            <ChevronLeftIcon size={24} data-id="element-38" />
          </motion.button>

          <motion.button whileHover={{
          scale: 1.1,
          backgroundColor: 'rgba(252, 211, 77, 1)'
        }} whileTap={{
          scale: 0.95
        }} onClick={goToNext} className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 text-white p-3 rounded-full transition-all duration-300 opacity-0 group-hover:opacity-100 backdrop-blur-sm" aria-label="Siguiente imagen" data-id="element-39">
            <ChevronRightIcon size={24} data-id="element-40" />
          </motion.button>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-41">
            {bodenorImages.map((_, index) => <motion.button key={index} onClick={() => {
            setDirection(index > currentIndex ? 1 : -1);
            setCurrentIndex(index);
          }} className={`rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-yellow-400 w-8 h-2' : 'bg-white/50 w-2 h-2 hover:bg-white/80'}`} whileHover={{
            scale: 1.2
          }} aria-label={`Ir a imagen ${index + 1}`} data-id="element-42" />)}
          </div>
        </div>
      </div>
    </section>;
}